import { Dimensions, Keyboard, Linking, Platform, StyleSheet, Text, View } from 'react-native'
import React from 'react'
import { ThemedText, ThemedView } from '@app/theme'
import WebView, { WebViewNavigation } from 'react-native-webview'
import { UPI_IDENTIFIERS } from '@app/configs/constants'

const MFCFetchModal = ({ url, onFetchComplete }: {
    url: any
    onFetchComplete: (url: any) => void
}) => {




    // function onNavigationStateChanged(webViewState: WebViewNavigation) {
    //     var regex = /[?&]([^=#]+)=([^&#]*)/g,
    //         params = {},
    //         match;
    //     while (match = regex.exec(webViewState.url)) {
    //         params[match[1]] = match[2];
    //     }
    // }



    return (
        <ThemedView pt='lg' borderTopLeftRadius='lg' borderTopRightRadius='lg' overflow='hidden' minHeight={Dimensions.get('screen').height - 100}>
            <WebView style={{ flex: 1 }} source={{ uri: url }}
                javaScriptEnabled={true}
                domStorageEnabled={true}
                onShouldStartLoadWithRequest={(request) => {
                    if (request.url.startsWith('https://app.voltmoney.in/?mfc_fetch_response=mfc')) {
                        onFetchComplete(request.url);
                        return false;
                    }
                    return true;
                }}
                originWhitelist={['*']}
                automaticallyAdjustContentInsets={false}
                useWebKit={true}
                allowsInlineMediaPlayback
                mediaPlaybackRequiresUserAction={false}
                javaScriptEnabledAndroid
                showsHorizontalScrollIndicator={false}
                nestedScrollEnabled={Platform.OS !== "web"}
                scalesPageToFit={false}
                scrollEnabled={Platform.OS === "ios"}
                forceDarkOn={false}
                injectedJavaScript={`              
                   $('form:first').css('max-width', '100%');
                   $('form:first').css('width', '100%');
                   $('div:first').removeClass("wrapper");
                   $('form:first').css('position', 'unset');
                   $('form:first').css('padding-bottom', '100%');
                   $('body').scrollTop({0});`
                }
            />
        </ThemedView>
    )
}

export default MFCFetchModal

const styles = StyleSheet.create({})